import { hooks, readOnly } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackAppOpened = () => {
  hooks.operations.subscribe(
    hooks.availableHooks.ON_AFTER_SITE_CONNECT,
    () => {
      trackEvent(constants.events.APP_OPENED_EVENT, {
        readOnlySession: readOnly.verifiers.isReadOnlyModeEnabled(),
      });
    },
    { once: true }
  );
};

export default trackAppOpened;
